// FormInput.js - Wiederverwendbare Formular-Input-Komponente
import React from 'react';

/**
 * Eine wiederverwendbare Input-Komponente für Formulare
 * 
 * @param {Object} props - Komponenteneigenschaften
 * @param {string} props.label - Label für das Eingabefeld
 * @param {string} props.name - Name des Eingabefelds (für formState)
 * @param {string} props.type - Typ des Eingabefelds (text, email, password, etc.)
 * @param {string} props.value - Aktueller Wert des Eingabefelds
 * @param {Function} props.onChange - Callback für Änderungen am Eingabefeld
 * @param {string} props.placeholder - Platzhaltertext
 * @param {boolean} props.required - Ob das Feld erforderlich ist
 * @param {string} props.error - Fehlermeldung für das Eingabefeld
 * @param {React.ReactNode} props.endAdornment - Element, das am Ende des Eingabefelds angezeigt wird
 */
const FormInput = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  endAdornment,
  ...rest
}) => {
  return (
    <div className="mb-4">
      {label && (
        <label 
          htmlFor={name} 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <div className="relative">
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={`
            mt-1 block w-full border rounded-md shadow-sm py-2 px-3
            ${error ? 'border-red-500' : 'border-gray-300'}
            focus:outline-none focus:ring-primary focus:border-primary
          `}
          {...rest}
        />
        
        {endAdornment && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            {endAdornment}
          </div>
        )}
      </div>
      
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
};

export default FormInput;
